// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { useEffect } from "react";

export function useKeyboardShortcuts({
  selectedElements,
  deleteSelected,
  isCreatingPolygon,
  completePolygon,
  setSelectedElements,
  setTool,
  undo,
  redo,
  copyElements,
  pasteElements,
  duplicateElements,
  groupElements,
  copySVGToClipboard,
  setShowPasteSVGDialog,
  toggleFloatingPanel,
  toggleRightPanel,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
        return;
      if (e.key === "Delete" && selectedElements.length > 0) {
        e.preventDefault();
        deleteSelected();
      } else if (e.key === "Escape") {
        e.preventDefault();
        if (isCreatingPolygon) {
          completePolygon();
        } else {
          setSelectedElements([]);
          setTool("select");
        }
      } else if ((e.ctrlKey || e.metaKey) && e.key === "z" && !e.shiftKey) {
        e.preventDefault();
        undo();
      } else if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === "y" || (e.key === "z" && e.shiftKey))
      ) {
        e.preventDefault();
        redo();
      } else if ((e.ctrlKey || e.metaKey) && e.key === "c") {
        e.preventDefault();
        copyElements();
      } else if ((e.ctrlKey || e.metaKey) && e.key === "v") {
        e.preventDefault();
        pasteElements();
      } else if ((e.ctrlKey || e.metaKey) && e.key === "d") {
        e.preventDefault();
        duplicateElements();
      } else if ((e.ctrlKey || e.metaKey) && e.key === "g") {
        e.preventDefault();
        if (selectedElements.length >= 2) {
          groupElements();
        }
      } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "C") {
        e.preventDefault();
        copySVGToClipboard();
      } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "V") {
        e.preventDefault();
        setShowPasteSVGDialog(true);
      } else if (e.key === "p" || e.key === "P") {
        e.preventDefault();
        toggleFloatingPanel();
      } else if (e.key === "l" || e.key === "L") {
        e.preventDefault();
        toggleRightPanel();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    selectedElements,
    deleteSelected,
    isCreatingPolygon,
    completePolygon,
    setSelectedElements,
    setTool,
    undo,
    redo,
    copyElements,
    pasteElements,
    duplicateElements,
    groupElements,
    copySVGToClipboard,
    setShowPasteSVGDialog,
    toggleFloatingPanel,
    toggleRightPanel,
  ]);
}
